import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from './material.module';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';
import { ErrorInfoModalComponent } from './components/error-info-modal/error-info-modal.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

@NgModule({
  declarations: [HeaderComponent, FooterComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MaterialModule,
    PhoneInputComponent,
    ErrorInfoModalComponent,
    ConfirmModalComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    CommonModule,
    MaterialModule,
    PhoneInputComponent,
    ErrorInfoModalComponent,
    ConfirmModalComponent,
  ],
})
export class SharedModule {}
